import axios from 'axios';
import { LEADS_SEND_ACTION, transitionLeads } from '../../../actions/naMotorInsurance/personalDetails';

export const leadsService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();

    (async () => {
        if (action.type === LEADS_SEND_ACTION) {
            await sendToEmail(store, state, action.gtmContext);
        }
    })();

    return result;
};

async function sendToEmail(store, state) {
    store.dispatch(transitionLeads.submitting());

    const bodyParams = {
        sourceEmailAddress: 'noreply@oldmutual.com',
        toEmailAdrress: 'NamibiaLeads@oldmutual.com',
        emailCampaignCode: 'Nam-STP-Vehicle-WB',
        subject: 'Motor Comprehensive Quote',
        type: 'namMotorQuote',
        source: 'MyOldMutualPublicWebsite',
        firstName: state.naMotorInsurance.personalDetails.form.firstName.value,
        lastName: state.naMotorInsurance.personalDetails.form.lastName.value,
        phoneNumber: state.naMotorInsurance.personalDetails.form.phoneNumber.value,
        emailAddress: state.naMotorInsurance.personalDetails.form.email.value,
        productName: 'Motor Quote',
        nationality: state.naMotorInsurance.personalDetails.form.nationality.value,
        idNumber: state.naMotorInsurance.personalDetails.form.idNumber.value ?? 'N/A',
        passportNumber: state.naMotorInsurance.personalDetails.form.passportNumber.value ?? 'N/A',
        dob: state.naMotorInsurance.personalDetails.form.dob.value,
        gender: state.naMotorInsurance.personalDetails.form.gender.value,
        town: state.naMotorInsurance.personalDetails.form.town.value,
        vehicleMake: state.naMotorInsurance.quote.form.carMake.value.name,
        vehicleModel: state.naMotorInsurance.quote.form.carModel.value.name,
        yearOfManufacture: state.naMotorInsurance.quote.form.yearOfManufacture.value,
        coverStartDate: state.naMotorInsurance.quote.form.coverStartDate.value,
        valuationValue: state.naMotorInsurance.quote.form.valuation.value,
        carAlarm: state.naMotorInsurance.quote.form.hasAlarm.value,
        trackingSystem: state.naMotorInsurance.quote.form.trackingSystem.value,
    };

    try {
        await axios.post('/om-api/call-me-back/call-me-back-mail', bodyParams, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        store.dispatch(transitionLeads.success());
    } catch (e) {
        store.dispatch(transitionLeads.error());
    }
}
